export default {
	namespaced: true,

	actions: {
		sendMessage({ commit }, { email, type, body }) {
			return axios.post('/feedback', { email, type, body, name: '-' });
		},
	},
};
